(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ec-cart"]) return;
  try {
    
  const cartSection = document.querySelector('.ec-cart');
  if (!cartSection) return;

  const summary = cartSection.querySelector('[data-ec-cart-summary]');
  const summaryToggle = cartSection.querySelector('[data-ec-cart-summary-toggle]');

  summaryToggle?.addEventListener('click', () => {
    if (!summary) return;
    summary.classList.toggle('is-collapsed');
    const expanded = !summary.classList.contains('is-collapsed');
    summaryToggle.setAttribute('aria-expanded', String(expanded));
    summaryToggle.setAttribute(
      'aria-label',
      expanded
        ? summaryToggle.dataset.hideSummary || 'Hide summary'
        : summaryToggle.dataset.showSummary || 'Show summary'
    );
  });

  cartSection.querySelectorAll('[data-ec-cart-quantity]').forEach((wrap) => {
    const input = wrap.querySelector('[data-ec-cart-qty-input]');
    const decrease = wrap.querySelector('[data-ec-cart-qty-decrease]');
    const increase = wrap.querySelector('[data-ec-cart-qty-increase]');

    decrease?.addEventListener('click', () => {
      const current = parseInt(input.value, 10) || 0;
      input.value = Math.max(0, current - 1);
    });

    increase?.addEventListener('click', () => {
      const current = parseInt(input.value, 10) || 0;
      input.value = current + 1;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ec-collection-main"] && !Shopify.designMode) return;
  try {
    
  const collectionSection = document.querySelector('.ec-collection');
  if (!collectionSection) return;

  const getCardGallery = (element) =>
    element?.closest('.ec-product-card')?.querySelector('[data-ec-card-gallery]');

  const setCardImage = (gallery, index) => {
    if (!gallery) return;

    gallery.dataset.ecCardIndex = String(index);
    gallery.classList.toggle('is-back-active', index === 1);

    const card = gallery.closest('.ec-product-card');
    if (!card) return;

    card.querySelectorAll('[data-ec-card-dot]').forEach((dot) => {
      const dotIndex = parseInt(dot.dataset.ecCardDotIndex, 10);
      const isActive = dotIndex === index;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    const prev = card.querySelector('[data-ec-card-prev]');
    const next = card.querySelector('[data-ec-card-next]');
    if (prev) prev.disabled = index === 0;
    if (next) next.disabled = index === 1;
  };

  collectionSection.addEventListener('click', (event) => {
    const prev = event.target.closest('[data-ec-card-prev]');
    const next = event.target.closest('[data-ec-card-next]');
    const dot = event.target.closest('[data-ec-card-dot]');

    if (!prev && !next && !dot) return;

    event.preventDefault();
    event.stopPropagation();

    const gallery = getCardGallery(prev || next || dot);
    if (!gallery) return;

    const currentIndex = parseInt(gallery.dataset.ecCardIndex, 10) || 0;

    if (prev) setCardImage(gallery, Math.max(0, currentIndex - 1));
    if (next) setCardImage(gallery, Math.min(1, currentIndex + 1));
    if (dot) setCardImage(gallery, parseInt(dot.dataset.ecCardDotIndex, 10) || 0);
  });

  collectionSection.querySelectorAll('[data-ec-card-gallery]').forEach((gallery) => {
    let touchStartX = 0;

    gallery.addEventListener(
      'touchstart',
      (event) => {
        touchStartX = event.changedTouches[0].clientX;
      },
      { passive: true }
    );

    gallery.addEventListener(
      'touchend',
      (event) => {
        const distance = event.changedTouches[0].clientX - touchStartX;
        if (Math.abs(distance) < 40) return;

        const currentIndex = parseInt(gallery.dataset.ecCardIndex, 10) || 0;

        if (distance < 0) {
          setCardImage(gallery, Math.min(1, currentIndex + 1));
        } else {
          setCardImage(gallery, Math.max(0, currentIndex - 1));
        }
      },
      { passive: true }
    );
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ec-customers"]) return;
  try {
    
  const customersSection = document.querySelector('.ec-customers');
  if (!customersSection) return;

  const loginPanel = customersSection.querySelector('[data-ec-login-panel]');
  const recoverPanel = customersSection.querySelector('[data-ec-recover-panel]');
  const showRecover = customersSection.querySelector('[data-ec-show-recover]');
  const showLogin = customersSection.querySelector('[data-ec-show-login]');

  showRecover?.addEventListener('click', () => {
    loginPanel.hidden = true;
    recoverPanel.hidden = false;
  });

  showLogin?.addEventListener('click', () => {
    recoverPanel.hidden = true;
    loginPanel.hidden = false;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ec-drop-slider"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ec-drop-slider]').forEach((section) => {
    const viewport = section.querySelector('[data-ec-drop-marquee]');
    const track = section.querySelector('[data-ec-drop-track]');
    const prevButton = section.querySelector('[data-ec-drop-prev]');
    const nextButton = section.querySelector('[data-ec-drop-next]');
    const dots = [...section.querySelectorAll('[data-ec-drop-dot]')];

    const originalCount = Number(section.dataset.ecDropCount) || dots.length || 0;

    if (!viewport || !track || originalCount === 0) return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const autoplayDelay = 2000;

    let isDragging = false;
    let pendingDrag = false;
    let dragStartX = 0;
    let dragScrollLeft = 0;
    let dragDistance = 0;
    let activePointerId = null;
    let touchStartX = 0;
    let touchStartY = 0;
    let userIsSwiping = false;
    let snapTimeout = null;
    let isAdjustingLoop = false;
    let autoplayTimer = null;
    let autoplayResumeTimeout = null;
    let isInitializing = true;

    const getItems = () => [...track.querySelectorAll('.ec-drop-slider__item')];
    const getMiddleSetOffset = () => (originalCount > 1 ? originalCount * 2 : 0);

    const getClosestItemIndex = () => {
      const items = getItems();
      if (!items.length) return 0;

      const viewportRect = viewport.getBoundingClientRect();
      const viewportCenter = viewportRect.left + viewportRect.width / 2;
      let closest = 0;
      let minDist = Infinity;

      items.forEach((item, index) => {
        const itemRect = item.getBoundingClientRect();
        const itemCenter = itemRect.left + itemRect.width / 2;
        const dist = Math.abs(itemCenter - viewportCenter);
        if (dist < minDist) {
          minDist = dist;
          closest = index;
        }
      });

      return closest;
    };

    const getSetWidth = () => {
      const items = getItems();
      if (originalCount <= 1 || items.length < originalCount * 3) return 0;

      const setStart = items[originalCount * 2];
      const nextSetStart = items[originalCount * 3];
      if (!setStart || !nextSetStart) return 0;

      return nextSetStart.offsetLeft - setStart.offsetLeft;
    };

    const loopScroll = () => {
      if (originalCount <= 1 || isAdjustingLoop) return;

      const closest = getClosestItemIndex();
      const setWidth = getSetWidth();
      if (setWidth <= 0) return;

      if (closest < originalCount) {
        isAdjustingLoop = true;
        viewport.scrollLeft += setWidth * 2;
        window.requestAnimationFrame(() => {
          isAdjustingLoop = false;
          updateUi();
        });
      } else if (closest >= originalCount * 4) {
        isAdjustingLoop = true;
        viewport.scrollLeft -= setWidth * 2;
        window.requestAnimationFrame(() => {
          isAdjustingLoop = false;
          updateUi();
        });
      }
    };

    const getRealIndex = () => {
      const closest = getClosestItemIndex();
      return ((closest % originalCount) + originalCount) % originalCount;
    };

    const scrollToItemIndex = (index, behavior = 'smooth') => {
      const items = getItems();
      const item = items[index];
      if (!item) return;

      const viewportRect = viewport.getBoundingClientRect();
      const itemRect = item.getBoundingClientRect();
      const delta =
        itemRect.left + itemRect.width / 2 - (viewportRect.left + viewportRect.width / 2);

      viewport.scrollTo({
        left: viewport.scrollLeft + delta,
        behavior: prefersReducedMotion ? 'auto' : behavior,
      });
    };

    const scrollToRealIndex = (realIndex, behavior = 'smooth') => {
      scrollToItemIndex(getMiddleSetOffset() + realIndex, behavior);
    };

    const updateUi = () => {
      const closest = getClosestItemIndex();
      const realIndex = getRealIndex();

      getItems().forEach((item, index) => {
        item.classList.toggle('is-active', index === closest);
      });

      dots.forEach((dot, index) => {
        dot.setAttribute('aria-current', index === realIndex ? 'true' : 'false');
      });
    };

    const snapToClosest = () => {
      loopScroll();
      scrollToItemIndex(getClosestItemIndex(), 'smooth');
      window.setTimeout(updateUi, prefersReducedMotion ? 0 : 280);
    };

    const scheduleSnap = () => {
      if (snapTimeout) clearTimeout(snapTimeout);
      snapTimeout = window.setTimeout(snapToClosest, prefersReducedMotion ? 0 : 100);
    };

    const scrollGallery = (direction) => {
      loopScroll();
      const realIndex = getRealIndex();
      const nextReal = (realIndex + direction + originalCount) % originalCount;
      scrollToRealIndex(nextReal, 'smooth');
      window.setTimeout(() => {
        loopScroll();
        updateUi();
      }, prefersReducedMotion ? 0 : 320);
    };

    const stopAutoplay = () => {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    };

    const startAutoplay = () => {
      if (prefersReducedMotion || originalCount <= 1 || document.hidden) return;

      stopAutoplay();
      autoplayTimer = window.setInterval(() => {
        if (isDragging || userIsSwiping || isAdjustingLoop || document.hidden) return;
        scrollGallery(1);
      }, autoplayDelay);
    };

    const resetAutoplay = () => {
      stopAutoplay();
      if (autoplayResumeTimeout) clearTimeout(autoplayResumeTimeout);
      if (prefersReducedMotion || originalCount <= 1) return;

      autoplayResumeTimeout = window.setTimeout(startAutoplay, autoplayDelay);
    };

    prevButton?.addEventListener('click', () => {
      scrollGallery(-1);
      resetAutoplay();
    });
    nextButton?.addEventListener('click', () => {
      scrollGallery(1);
      resetAutoplay();
    });

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const targetIndex = Number(dot.dataset.ecDropDot);
        if (Number.isNaN(targetIndex)) return;
        scrollToRealIndex(targetIndex, 'smooth');
        window.setTimeout(() => {
          loopScroll();
          updateUi();
        }, prefersReducedMotion ? 0 : 320);
        resetAutoplay();
      });
    });

    viewport.addEventListener('mouseenter', stopAutoplay);
    viewport.addEventListener('mouseleave', startAutoplay);

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        stopAutoplay();
      } else {
        startAutoplay();
      }
    });

    viewport.addEventListener(
      'scroll',
      () => {
        if (isAdjustingLoop) return;
        loopScroll();
        updateUi();
      },
      { passive: true }
    );

    viewport.addEventListener(
      'touchstart',
      (event) => {
        touchStartX = event.touches[0].clientX;
        touchStartY = event.touches[0].clientY;
        userIsSwiping = false;
        stopAutoplay();
      },
      { passive: true }
    );

    viewport.addEventListener(
      'touchmove',
      (event) => {
        const deltaX = Math.abs(event.touches[0].clientX - touchStartX);
        const deltaY = Math.abs(event.touches[0].clientY - touchStartY);
        if (deltaX > 8 && deltaX > deltaY) {
          userIsSwiping = true;
        }
      },
      { passive: true }
    );

    viewport.addEventListener(
      'touchend',
      () => {
        if (userIsSwiping) scheduleSnap();
        userIsSwiping = false;
        resetAutoplay();
      },
      { passive: true }
    );

    viewport.addEventListener(
      'touchcancel',
      () => {
        userIsSwiping = false;
      },
      { passive: true }
    );

    viewport.addEventListener(
      'pointerdown',
      (event) => {
        if (event.pointerType === 'touch') return;
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        stopAutoplay();
        pendingDrag = true;
        isDragging = false;
        dragDistance = 0;
        dragStartX = event.clientX;
        dragScrollLeft = viewport.scrollLeft;
        activePointerId = event.pointerId;
      },
      { passive: true }
    );

    viewport.addEventListener(
      'pointermove',
      (event) => {
        if (!pendingDrag && !isDragging) return;
        if (activePointerId != null && event.pointerId !== activePointerId) return;

        const delta = event.clientX - dragStartX;
        dragDistance = Math.max(dragDistance, Math.abs(delta));

        if (!isDragging && Math.abs(delta) > 8) {
          isDragging = true;
          pendingDrag = false;
          viewport.classList.add('is-dragging');
          viewport.setPointerCapture(event.pointerId);
        }

        if (!isDragging) return;

        viewport.scrollLeft = dragScrollLeft - delta;
        loopScroll();
      },
      { passive: true }
    );

    const endDrag = (event) => {
      if (activePointerId != null && event?.pointerId != null && event.pointerId !== activePointerId) {
        return;
      }

      pendingDrag = false;
      activePointerId = null;

      if (!isDragging) {
        resetAutoplay();
        return;
      }

      isDragging = false;
      viewport.classList.remove('is-dragging');
      if (event?.pointerId != null && viewport.hasPointerCapture(event.pointerId)) {
        viewport.releasePointerCapture(event.pointerId);
      }
      scheduleSnap();
      resetAutoplay();
    };

    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);

    viewport.addEventListener(
      'click',
      (event) => {
        if (dragDistance > 8) {
          event.preventDefault();
          event.stopPropagation();
        }
        dragDistance = 0;
      },
      true
    );

    viewport.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        scrollGallery(-1);
        resetAutoplay();
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        scrollGallery(1);
        resetAutoplay();
      }
    });

    const initSlider = () => {
      const alignSlider = () => {
        scrollToItemIndex(getMiddleSetOffset(), 'auto');
        updateUi();
      };

      alignSlider();
      window.requestAnimationFrame(() => {
        alignSlider();
        isInitializing = false;
      });

      track.querySelectorAll('img').forEach((image) => {
        if (image.complete) return;
        image.addEventListener('load', alignSlider, { once: true });
      });

      startAutoplay();
    };

    let resizeFrame = null;
    const resizeObserver = new ResizeObserver(() => {
      if (isInitializing || isDragging || isAdjustingLoop || userIsSwiping) return;
      if (resizeFrame) cancelAnimationFrame(resizeFrame);
      resizeFrame = requestAnimationFrame(() => {
        scrollToRealIndex(getRealIndex(), 'auto');
        updateUi();
      });
    });
    resizeObserver.observe(viewport);

    if (document.fonts?.ready) {
      document.fonts.ready.then(initSlider);
    } else {
      window.requestAnimationFrame(initSlider);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ec-featured-collections"] && !Shopify.designMode) return;
  try {
    
  const collectionsSection = document.querySelector('.ec-collections');
  if (!collectionsSection) return;

  const getCardGallery = (element) =>
    element?.closest('.ec-product-card')?.querySelector('[data-ec-card-gallery]');

  const setCardImage = (gallery, index) => {
    if (!gallery) return;

    gallery.dataset.ecCardIndex = String(index);
    gallery.classList.toggle('is-back-active', index === 1);

    const card = gallery.closest('.ec-product-card');
    if (!card) return;

    card.querySelectorAll('[data-ec-card-dot]').forEach((dot) => {
      const dotIndex = parseInt(dot.dataset.ecCardDotIndex, 10);
      const isActive = dotIndex === index;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    const prev = card.querySelector('[data-ec-card-prev]');
    const next = card.querySelector('[data-ec-card-next]');
    if (prev) prev.disabled = index === 0;
    if (next) next.disabled = index === 1;
  };

  collectionsSection.addEventListener('click', (event) => {
    const prev = event.target.closest('[data-ec-card-prev]');
    const next = event.target.closest('[data-ec-card-next]');
    const dot = event.target.closest('[data-ec-card-dot]');

    if (!prev && !next && !dot) return;

    event.preventDefault();
    event.stopPropagation();

    const gallery = getCardGallery(prev || next || dot);
    if (!gallery) return;

    const currentIndex = parseInt(gallery.dataset.ecCardIndex, 10) || 0;

    if (prev) setCardImage(gallery, Math.max(0, currentIndex - 1));
    if (next) setCardImage(gallery, Math.min(1, currentIndex + 1));
    if (dot) setCardImage(gallery, parseInt(dot.dataset.ecCardDotIndex, 10) || 0);
  });

  collectionsSection.querySelectorAll('[data-ec-card-gallery]').forEach((gallery) => {
    let touchStartX = 0;

    gallery.addEventListener(
      'touchstart',
      (event) => {
        touchStartX = event.changedTouches[0].clientX;
      },
      { passive: true }
    );

    gallery.addEventListener(
      'touchend',
      (event) => {
        const distance = event.changedTouches[0].clientX - touchStartX;
        if (Math.abs(distance) < 40) return;

        const currentIndex = parseInt(gallery.dataset.ecCardIndex, 10) || 0;

        if (distance < 0) {
          setCardImage(gallery, Math.min(1, currentIndex + 1));
        } else {
          setCardImage(gallery, Math.max(0, currentIndex - 1));
        }
      },
      { passive: true }
    );
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ec-product-main"]) return;
  try {
    
  const productSection = document.querySelector('.ec-product');
  if (!productSection) return;

  const productData = JSON.parse(
    productSection.querySelector('[data-ec-product-json]').textContent
  );
  const variantInput = productSection.querySelector('[data-ec-variant-id]');
  const priceEl = productSection.querySelector('[data-ec-product-price]');
  const addToCartBtn = productSection.querySelector('[data-ec-add-to-cart]');
  const mainImage = productSection.querySelector('#ec-product-main-image');
  const mainMedia = productSection.querySelector('[data-ec-main-media]');
  const galleryDots = productSection.querySelectorAll('[data-ec-gallery-dot]');
  const galleryPrev = productSection.querySelector('[data-ec-gallery-prev]');
  const galleryNext = productSection.querySelector('[data-ec-gallery-next]');
  const quantityInput = productSection.querySelector('[data-ec-quantity-input]');
  const currency = priceEl?.dataset.currency || 'USD';

  const getActiveGalleryIndex = () => {
    const activeIndex = Array.from(galleryDots).findIndex((button) =>
      button.classList.contains('is-active')
    );
    return activeIndex >= 0 ? activeIndex : 0;
  };

  const updateGalleryControls = (activeIndex) => {
    galleryDots.forEach((dot, index) => {
      const isActive = index === activeIndex;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    if (galleryPrev) {
      galleryPrev.disabled = activeIndex === 0;
    }

    if (galleryNext) {
      galleryNext.disabled = activeIndex === galleryDots.length - 1;
    }
  };

  const getActiveGalleryIndexFromButton = (button) => {
    const index = parseInt(button.dataset.mediaIndex, 10);
    return Number.isNaN(index) ? 0 : index;
  };

  const setMainImage = (button) => {
    if (!mainImage || !button?.dataset.mediaSrc) return;

    mainImage.classList.add('is-swapping');

    mainImage.src = button.dataset.mediaSrc;
    if (button.dataset.mediaSrcset) {
      mainImage.srcset = button.dataset.mediaSrcset;
    } else {
      mainImage.removeAttribute('srcset');
    }

    mainImage.dataset.mediaId = button.dataset.mediaId;

    updateGalleryControls(getActiveGalleryIndexFromButton(button));

    requestAnimationFrame(() => {
      mainImage.classList.remove('is-swapping');
    });
  };

  const goToGalleryIndex = (index) => {
    const button = galleryDots[index];
    if (button) setMainImage(button);
  };

  const productForm = productSection.querySelector('[data-ec-product-form]');
  const useSizeVariants = productForm?.dataset.ecUseSizeVariants === 'true';

  const findVariant = () => {
    if (!useSizeVariants) {
      return (
        productData.variants.find((variant) => variant.id === Number(variantInput.value)) ||
        productData.variants[0]
      );
    }

    const selectedOptions = [];
    productSection.querySelectorAll('[data-ec-option-input]:checked:not(:disabled)').forEach((input) => {
      const index = parseInt(input.dataset.optionIndex, 10);
      if (!Number.isNaN(index)) {
        selectedOptions[index] = input.value;
      }
    });

    return productData.variants.find((variant) =>
      variant.options.every((option, index) => option === selectedOptions[index])
    );
  };

  const updateVariant = () => {
    const variant = findVariant();
    if (!variant) return;

    variantInput.value = variant.id;

    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      priceEl.innerHTML = `
        <span class="ec-product__price-sale">${formatMoney(variant.price)}</span>
        <span class="ec-product__price-compare">${formatMoney(variant.compare_at_price)}</span>
      `;
    } else {
      priceEl.textContent = formatMoney(variant.price);
    }

    if (addToCartBtn) {
      addToCartBtn.disabled = !variant.available;
      addToCartBtn.textContent = variant.available
        ? addToCartBtn.dataset.labelAvailable
        : addToCartBtn.dataset.labelSoldOut;
    }

    if (variant.featured_media) {
      const dot = productSection.querySelector(
        `.ec-product__gallery-dot[data-media-id="${variant.featured_media.id}"]`
      );
      if (dot) setMainImage(dot);
    }
  };

  productSection.querySelectorAll('[data-ec-option-input]').forEach((input) => {
    input.addEventListener('change', updateVariant);
  });

  galleryDots.forEach((dot) => {
    dot.addEventListener('click', () => {
      const index = parseInt(dot.dataset.mediaIndex, 10);
      if (!Number.isNaN(index)) goToGalleryIndex(index);
    });
  });

  galleryPrev?.addEventListener('click', () => {
    goToGalleryIndex(Math.max(0, getActiveGalleryIndex() - 1));
  });

  galleryNext?.addEventListener('click', () => {
    goToGalleryIndex(Math.min(galleryDots.length - 1, getActiveGalleryIndex() + 1));
  });

  if (mainMedia && galleryDots.length > 1) {
    let touchStartX = 0;

    mainMedia.addEventListener(
      'touchstart',
      (event) => {
        touchStartX = event.changedTouches[0].clientX;
      },
      { passive: true }
    );

    mainMedia.addEventListener(
      'touchend',
      (event) => {
        const touchEndX = event.changedTouches[0].clientX;
        const distance = touchEndX - touchStartX;

        if (Math.abs(distance) < 40) return;

        const currentIndex = getActiveGalleryIndex();

        if (distance < 0) {
          goToGalleryIndex(Math.min(galleryDots.length - 1, currentIndex + 1));
        } else {
          goToGalleryIndex(Math.max(0, currentIndex - 1));
        }
      },
      { passive: true }
    );
  }

  updateGalleryControls(getActiveGalleryIndex());

  const formatMoney = (cents) =>
    new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency,
    }).format(cents / 100);

  const quantityDecrease = productSection.querySelector('[data-ec-quantity-decrease]');
  const quantityIncrease = productSection.querySelector('[data-ec-quantity-increase]');

  if (quantityInput && quantityDecrease) {
    quantityDecrease.addEventListener('click', () => {
      const current = parseInt(quantityInput.value, 10) || 1;
      quantityInput.value = Math.max(1, current - 1);
    });
  }

  if (quantityInput && quantityIncrease) {
    quantityIncrease.addEventListener('click', () => {
      const current = parseInt(quantityInput.value, 10) || 1;
      quantityInput.value = current + 1;
    });
  }

  const customizeBuyNowButton = () => {
    const checkoutWrap = productSection.querySelector('[data-ec-dynamic-checkout]');
    if (!checkoutWrap) return;

    const buyNowLabel = checkoutWrap.dataset.buyNowLabel || 'Buy now';
    const buyNowButton = checkoutWrap.querySelector('.shopify-payment-button__button--unbranded');

    if (buyNowButton && !buyNowButton.dataset.ecCustomized) {
      buyNowButton.dataset.ecCustomized = 'true';
      buyNowButton.textContent = buyNowLabel.toUpperCase();
      buyNowButton.setAttribute('aria-label', buyNowLabel);
    }
  };

  customizeBuyNowButton();

  const checkoutObserver = new MutationObserver(() => {
    customizeBuyNowButton();
  });

  const checkoutWrap = productSection.querySelector('[data-ec-dynamic-checkout]');
  if (checkoutWrap) {
    checkoutObserver.observe(checkoutWrap, { childList: true, subtree: true });
  }

  const updateHeaderCartCount = async () => {
    try {
      const response = await fetch('/cart.js');
      if (!response.ok) return;

      const cart = await response.json();
      const cartButton = document.querySelector('.site-header__cart');
      if (!cartButton) return;

      let countBadge = cartButton.querySelector('.site-header__cart-count');

      if (cart.item_count > 0) {
        if (!countBadge) {
          countBadge = document.createElement('sup');
          countBadge.className = 'site-header__cart-count';
          cartButton.appendChild(countBadge);
        }
        countBadge.textContent = String(cart.item_count);
      } else if (countBadge) {
        countBadge.remove();
      }
    } catch (error) {
      /* ignore */
    }
  };

  productForm?.addEventListener('submit', async (event) => {
    const submitter = event.submitter;

    if (submitter && !submitter.hasAttribute('data-ec-add-to-cart')) {
      return;
    }

    event.preventDefault();

    if (!addToCartBtn || addToCartBtn.disabled) return;

    const formData = new FormData(productForm);
    const variantId = Number(formData.get('id'));
    const quantity = Number(formData.get('quantity')) || 1;

    if (!variantId) return;

    const item = { id: variantId, quantity };
    const sizeProperty = formData.get('properties[Size]');

    if (sizeProperty) {
      item.properties = { Size: sizeProperty };
    }

    addToCartBtn.disabled = true;
    const originalLabel = addToCartBtn.textContent;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [item] }),
      });

      if (!response.ok) {
        throw new Error('Add to cart failed');
      }

      addToCartBtn.textContent = addToCartBtn.dataset.labelAdded || 'Added';
      await updateHeaderCartCount();

      if (typeof window.ecRefreshCartDrawer === 'function') {
        await window.ecRefreshCartDrawer();
      }

      if (typeof window.ecOpenCartDrawer === 'function') {
        window.ecOpenCartDrawer();
      }

      window.setTimeout(() => {
        updateVariant();
        addToCartBtn.textContent = originalLabel;
      }, 1600);
    } catch (error) {
      addToCartBtn.disabled = false;
      addToCartBtn.textContent = originalLabel;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const header = document.querySelector('.site-header');
  if (!header) return;

  const toggle = header.querySelector('.site-header__menu-toggle');
  const drawer = header.querySelector('.site-header__drawer');
  const closeButton = header.querySelector('.site-header__drawer-close');
  const backdrop = header.querySelector('.site-header__backdrop');

  const openDrawer = () => {
    drawer.hidden = false;
    backdrop.hidden = false;
    header.classList.add('site-header--menu-open');
    requestAnimationFrame(() => {
      drawer.classList.add('is-open');
    });
    toggle.setAttribute('aria-expanded', 'true');
    document.documentElement.style.overflow = 'hidden';
  };

  const closeDrawer = () => {
    drawer.classList.remove('is-open');
    header.classList.remove('site-header--menu-open');
    toggle.setAttribute('aria-expanded', 'false');
    document.documentElement.style.overflow = '';
    window.setTimeout(() => {
      drawer.hidden = true;
      backdrop.hidden = true;
    }, 300);
  };

  toggle?.addEventListener('click', openDrawer);
  closeButton?.addEventListener('click', closeDrawer);
  backdrop?.addEventListener('click', closeDrawer);

  drawer?.querySelectorAll('a, [data-ec-open-cart-drawer]').forEach((link) => {
    link.addEventListener('click', () => {
      closeDrawer();
    });
  });

  if (header.classList.contains('site-header--hero-home')) {
    const hero = document.querySelector('.ec-hero');

    if (hero) {
      const updateLogoVisibility = () => {
        const heroBottom = hero.getBoundingClientRect().bottom;
        const headerBottom = header.getBoundingClientRect().bottom;
        const isPastHero = heroBottom <= headerBottom + 1;

        header.classList.toggle('site-header--logo-visible', isPastHero);
      };

      updateLogoVisibility();
      window.addEventListener('scroll', updateLogoVisibility, { passive: true });
      window.addEventListener('resize', updateLogoVisibility, { passive: true });
    } else {
      header.classList.add('site-header--logo-visible');
    }
  }

  } catch(e) { console.error(e); }
})();
})();
